module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/antiBacterial_10736d.png";